// src/components/store/sections/faqs/FaqV34ClaytogglesTealLagoon.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV34ClaytogglesTealLagoon(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={34}
      archKey="clay_toggles"
      archLabel="3D Claymorphic Toggles"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
